var
    /** @type {function(new:module.undoRedo.Settings)} */
    Settings = require('diy/undo-redo/Settings'),
    /** @type {module.undoRedo.Settings} */
    settings,

    /** @type {function(new:module.undoRedo.FeatureSet)} */
    FeatureSet = require('diy/undo-redo/FeatureSet'),
    /** @type {module.undoRedo.FeatureSet} */
    featureSet,

    /** @type {function(new:module.undoRedo.PluginRegistry)} */
    PluginRegistry = require('diy/undo-redo/PluginRegistry'),
    /** @type {module.undoRedo.PluginRegistry} */
    pluginRegistry,

    /** @type {function(new:module.undoRedo.SessionFactory)} */
    SessionFactory = require('diy/undo-redo/SessionFactory'),
    /** @type {module.undoRedo.SessionFactory} */
    sessionFactory,

    /** @type {function(new:module.undoRedo.SessionManager)} */
    SessionManager = require('diy/undo-redo/SessionManager'),
    /** @type {module.undoRedo.SessionManager} */
    sessionManager,

    /** @type {function(new:module.undoRedo.EntryFactory)} */
    EntryFactory = require('diy/undo-redo/EntryFactory'),
    /** @type {module.undoRedo.EntryFactory} */
    entryFactory,

    /** @type {function(new:module.undoRedo.History)} */
    History = require('diy/undo-redo/History'),
    /** @type {module.undoRedo.History} */
    history,

    /** @type {function(new:module.undoRedo.HistoryEntry.Factory)} */
    HistoryEntryFactory = require('diy/undo-redo/historyEntry/Factory'),
    /** @type {module.undoRedo.HistoryEntry.Factory} */
    historyEntryFactory,

    /** @type {function(new:module.undoRedo.PouchAdapter)} */
    PouchAdapter = require('diy/undo-redo/PouchAdapter'),
    /** @type {module.undoRedo.PouchAdapter} */
    database,

    /** @type {function(new:module.undoRedo.Storage)} */
    AppStorage = require('diy/undo-redo/Storage'),
    /** @type {module.undoRedo.Storage} */
    storage,

    /** @type {function(new:module.undoRedo.Ui)} */
    Ui = require('diy/undo-redo/Ui'),
    /** @type {module.undoRedo.Ui} */
    ui,

    /** @type {function(new:module.undoRedo.UiManager)} */
    UiManager = require('diy/undo-redo/UiManager'),
    /** @type {module.undoRedo.UiManager} */
    uiManager,

    /** @type {function(new:module.undoRedo.Executor.Main)} */
    Executor = require('diy/undo-redo/executor/Main'),
    /** @type {module.undoRedo.Executor.Main} */
    executor,

    /** @type {function(new:module.undoRedo.Executor.Factory)} */
    ExecutorFactory = require('diy/undo-redo/executor/Factory'),
    /** @type {module.undoRedo.Executor.Factory} */
    executorFactory,

    /** @type {function(new:module.undoRedo.Queue)} */
    Queue = require('diy/undo-redo/Queue'),

    /** @type {function(new:module.undoRedo.RemoteRequest)} */
    RemoteRequest = require('diy/undo-redo/RemoteRequest'),
    /** @type {module.undoRedo.RemoteRequest} */
    backend,

    /** @type {module.undoRedo.constants} */
    constants = require('diy/undo-redo/constants'),


    /** @type {function(new:module.undoRedo.App)} */
    App = require('diy/undo-redo/App'),
    /** @type {module.undoRedo.App} */
    app,

    /** @type {function(new:module.undoRedo.Api)} */
    Api = require('diy/undo-redo/Api'),
    /** @type {module.undoRedo.Api} */
    api,

    /** @type {function(new:module.undoRedo.plugins.Module)} */
    ModulePlugin = require('diy/undo-redo/plugins/Module'),
    /** @type {module.undoRedo.plugins.Module} */
    modulePlugin,

    /** @type {function(new:module.undoRedo.plugins.Layout)} */
    LayoutPlugin = require('diy/undo-redo/plugins/Layout'),
    /** @type {module.undoRedo.plugins.Layout} */
    layoutPlugin,

    /** @type {function(new:module.undoRedo.plugins.Design)} */
    DesignPlugin = require('diy/undo-redo/plugins/Design'),
    /** @type {module.undoRedo.plugins.Design} */
    designPlugin,

    /** @type {diy.util.l10n} */
    l10n = require('diy/util/l10n').getString,

    /** @type {diy.util.globalEvents} */
    globalEvents = require('diy/util/globalEvents'),

    /**
     * Plugin management
     *
     * @param {module.undoRedo.Api} api
     */
    registerPlugins = function (api) {
        layoutPlugin = new LayoutPlugin(api);
        designPlugin = new DesignPlugin(api);
        modulePlugin = new ModulePlugin(api);

        api
            .registerPlugin(layoutPlugin)
            .registerPlugin(designPlugin)
            .registerPlugin(modulePlugin)
        ;
    },

    loadTranslations = function () {
        return {
            tooltipClickHereToUndo: l10n('undoRedo.tooltipClickHereToUndo'),
            tooltipClickHereToRedo: l10n('undoRedo.tooltipClickHereToRedo'),
            tooltipCanNotBeUndone: l10n('undoRedo.tooltipCanNotBeUndone'),
            loadingText: l10n('undoRedo.loadingText'),
            errors: {
                generic: {
                    title: l10n('undoRedo.errors.generic.title'),
                    description: l10n('undoRedo.errors.generic.description'),
                    button: l10n('undoRedo.errors.generic.button')
                },
                timeout: {
                    title: l10n('undoRedo.errors.generic.title'),
                    description: l10n('undoRedo.errors.generic.description'),
                    button: l10n('undoRedo.errors.generic.button')
                },
                privateMode: {
                    title: l10n('undoRedo.errors.privateMode.title'),
                    description: l10n('undoRedo.errors.privateMode.description')
                }
            }
        };
    },

    startApi = function () {

        featureSet = new FeatureSet();
        settings = new Settings(featureSet);
        pluginRegistry = new PluginRegistry();
        backend = new RemoteRequest();
        app = new App(settings, featureSet);
        api = new Api(app, settings, featureSet, pluginRegistry);

        sessionFactory = new SessionFactory();
        sessionManager = new SessionManager(app, sessionFactory);
        historyEntryFactory = new HistoryEntryFactory(api);
        app
            .setApi(api)
            .setSessionManager(sessionManager)
            .setHistoryEntryFactory(historyEntryFactory)
        ;

        registerPlugins(api);
        return api;
    },

    onReady = function (features, toolbar) {
        var ini, messages;
        messages = loadTranslations();
        featureSet.load(features, settings);

        ini = settings.getIni();

        ui = new Ui(api, ini.displayLimit, messages, featureSet, toolbar);
        uiManager = new UiManager(ui, api);
        entryFactory = new EntryFactory(api);

        history = new History(entryFactory, new Queue(), backend, sessionManager, ini.localEntriesLimit);
        database = new PouchAdapter(ini.localStorageName);
        storage = new AppStorage(backend);
        executor = new Executor(history, backend, api);
        executorFactory = new ExecutorFactory(history, backend, api);
        executor.setFactory(executorFactory);

        app.init(history, database, storage, entryFactory, ui, uiManager, executor, backend, messages)
            .catch(function (error) {
                if (!error.wasHandled) {
                    globalEvents.trigger('error.diy-editor', {
                        message: 'UndoRedo initialization error: message = ' + error.message + ', stack = ' + error.stack
                    });
                }
            })
            .done(function () {
                api.onAppReady();
            });
    };

module.exports = {
    startApi: startApi,
    onReady: onReady
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/UndoRedo.js
 ** module id = 887
 ** module chunks = 0
 **/